import axios from 'axios';
import qs from 'qs';
import {
  LINEPAY_API_PATH,
} from '@/api/path';

export const userRequest = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  withCredentials: process.env.NODE_ENV === 'development' ? false : true,
});
export const postFunc = (path, data) => userRequest.post(`${ LINEPAY_API_PATH }${ path }`, qs.stringify(data));
export const postFuncWithoutParse = (path, data) => userRequest.post(`${ LINEPAY_API_PATH }${ path }`, qs.stringify(data), {
  transformResponse: (res) => { return res; }, // 不要把結果 JSON.parse
});
export const getFunc = path => userRequest.get(`${ LINEPAY_API_PATH }${ path }`);

export const createLinePayTransaction = async(data) => await postFuncWithoutParse('/v3/createLinePayTransaction.php', data);

export const confirmLinePayTransaction = async(data) => await postFunc('/v3/confirmLinePayTransaction.php', data);
